import { createContext } from 'preact';

// TODO schema
export type ViewContextType = {
	props: {
		service: {
			id: string;
			href?: string;
			logo: {
				src: string;
				height: number;
			};
			icon?: {
				src: string;
				label: string;
			};
			sbr?: boolean;
		};
	};
};

const ViewContext = createContext<ViewContextType>(null!);

export default ViewContext;
